// Single source of truth for the sidebar menu and the header breadcrumb.
// The active page is worked out from the URL, so pages don't need to report it.
import {
    LuLayoutDashboard,
    LuUsers,
    LuArrowLeftRight,
    LuTicket,
    LuPercent,
    LuPlug,
    LuSettings,
    LuBookOpen,
    LuChartLine,
    LuMegaphone
} from 'react-icons/lu';

export const NAV_ITEMS = [
    { label: 'Dashboard', icon: LuLayoutDashboard, path: '/dashboard' },
    {
        label: 'User Center',
        icon: LuUsers,
        children: [{ label: 'All Users', path: '/users/all' }],
    },
    {
        label: 'Broadcast',
        icon: LuMegaphone,
        children: [
            { label: 'New Broadcast', path: '/broadcast/new-broadcast' },
            { label: 'Recent Broadcast', path: '/broadcast/recent-broadcast' }
        ],
    },
    {
        label: 'Transaction',
        icon: LuArrowLeftRight,
        children: [
            { label: 'Pending Transaction', path: '/transaction/pending' },
            { label: 'Mobile & DTH', path: '/transaction/mobile-dth' },
            { label: 'Bill Payment', path: '/transaction/bill-payment' },
            { label: 'Payment', path: '/transaction/payment' },
            { label: 'All Payment', path: '/transaction/all-payment' },
            { label: 'Transaction Report', path: '/transaction/report' },
        ],
    },
    { label: 'Ticket', icon: LuTicket, path: '/ticket' },
    {
        label: 'Margin',
        icon: LuPercent,
        children: [
            { label: 'Margin Plan', path: '/margin/plan' },
            { label: 'Margin Setup', path: '/margin/setup' },
        ],
    },
    {
        label: 'API',
        icon: LuPlug,
        children: [
            { label: 'All Provider', path: '/api/providers' },
            { label: 'API Balance', path: '/api/balance' },
        ],
    },
    {
        label: 'Setting',
        icon: LuSettings,
        children: [
            { label: 'Operator', path: '/setting/operator' },
            { label: 'Banner', path: '/setting/banner' },
            { label: 'Service Provider', path: '/setting/service-provider' },
        ],
    },
    {
        label: 'Khatabook',
        icon: LuBookOpen,
        children: [
            { label: 'Bank', path: '/khatabook/bank' },
            { label: 'Party', path: '/khatabook/party' },
            { label: 'Payment Out', path: '/khatabook/payment?type=OUT' },
            { label: 'Payment In', path: '/khatabook/payment?type=IN' },
            { label: 'Report', path: '/khatabook/report' },
        ],
    },
    {
        label: 'Analytics',
        icon: LuChartLine,
        children: [
            { label: 'User Balance', path: '/analytics/user-balance' },
            { label: 'Recharge', path: '/analytics/recharge' },
            { label: 'Bill Payment', path: '/analytics/bill-payment' },
            { label: 'Payment', path: '/analytics/payment' },
        ],
    },
];

// Pages reached from the header or from inside other pages, not from the sidebar
const OTHER_PAGES = [
    { section: 'Transaction', label: 'Live Transactions', path: '/transaction/live' },
    { section: 'Transaction', label: 'Ledger', path: '/transaction/ledger' },
    { section: 'API', label: 'Provider Setup', path: '/api/provider-setup' },
    { label: 'Notifications', path: '/notification' },
    { label: 'My Profile', path: '/profile' },
    { label: 'Help & Support', path: '/support' },
    { label: 'Theme Settings', path: '/theme' },
];

const ALL_PAGES = [
    ...NAV_ITEMS.flatMap((item) =>
        item.children
            ? item.children.map((child) => ({ ...child, section: item.label }))
            : [{ label: item.label, path: item.path }]
    ),
    ...OTHER_PAGES,
];

const splitPath = (path) => {
    const [pathname, query = ''] = path.split('?');
    return { pathname, params: new URLSearchParams(query) };
};

// True when `path` (which may carry a query, e.g. '/khatabook/payment?type=IN')
// points at the current location.
export const isPathActive = (path, location) => {
    const { pathname, params } = splitPath(path);
    if (pathname !== location.pathname) return false;
    const current = new URLSearchParams(location.search);
    for (const [key, value] of params) {
        if (current.get(key) !== value) return false;
    }
    return true;
};

// { section, label } for the current location; falls back to a pathname-only match
export const getPageMeta = (location) =>
    ALL_PAGES.find((page) => isPathActive(page.path, location)) ||
    ALL_PAGES.find((page) => splitPath(page.path).pathname === location.pathname) ||
    { label: 'Dashboard' };
